import { reducer as toastrReducer } from "react-redux-toastr"
import { routerReducer } from "react-router-redux"

import loading, * as fromLoading from "./red_loading"
import products from "./red_products"
import supplierParameters from "./red_supplier-parameters"
import referenceIsgUrls from "./red_reference-isg-urls"
import lang, * as fromLang from "./red_lang"
import sidebar, * as fromSidebar from "./red_sidebar"
import user, * as fromUser from "./red_user"
import translations, * as fromTranslations from "./red_translations"
import productForm from "../../ui/product-form/_reducers"
import miscellaneous from "./miscellaneous"
import { format } from "util"
import { object } from "prop-types"
import combineReducers, {
  StateFromReducersMapObject,
} from "../../utils/combine-reducer"
import { createSelector } from "../../utils/memo"

const reducers = {
  loading,
  lang,
  products,
  supplierParameters,
  referenceIsgUrls,
  sidebar,
  user,
  translations,
  productForm,
  miscellaneous,
  router: routerReducer,
  toastr: toastrReducer,
}

export type DropitState = StateFromReducersMapObject<typeof reducers>

export default combineReducers<typeof reducers>({ ...reducers })

export const getTranslations = (state: DropitState) =>
  fromTranslations.getTranslationTexts(state.translations)
export const getTranslationsByScope = (state: DropitState, scope: string) =>
  fromTranslations.getTranslationTextsByScope(state.translations, scope)
export const getTranslationsByScopes = (state: DropitState, scopes: string[]) =>
  fromTranslations.getTranslationTextsByScopes(state.translations, scopes)

export const getUserRole = (state: DropitState) => fromUser.getRole(state.user)
export const getUserManagedSupplierList = (state: DropitState) =>
  fromUser.getManagedSupplierList(state.user)
export const getUserSelectedSupplier = (state: DropitState) =>
  fromUser.getSelectedSupplier(state.user)
export const getSelectedSupplierBusinessUnit = (state: DropitState) =>
  fromUser.getSupplierBusinessUnit(state.user)
export const getSelfBusinessUnit = (state: DropitState) =>
  fromUser.getCurrentUserBusinessUnit(state.user)

export const isSidebarOpened = (state: DropitState) =>
  fromSidebar.isSidebarOpened(state.sidebar)

export const getActiveLang = (state: DropitState) => state.lang

export const getSupplierParameters = (state: DropitState) => {
  return state.supplierParameters
}

// The tree components expect an array of root nodes; build it once per loaded tree.
export const getTechPropNodes = createSelector(
  [(state: DropitState) => state.miscellaneous.techTree.data],
  (data: any) => [data]
)
export const getComPropNodes = createSelector(
  [(state: DropitState) => state.miscellaneous.comTree.data],
  (data: any) => [data]
)
